import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './confirmModal.module.scss';

const cx = classnames.bind(styles);

interface ConfirmModalProps {
  size?: 'xlarge' | 'large';
  title?: React.ReactNode;
  description?: React.ReactNode;
  onConfirm?: () => void;
  onClose?: () => void;
}

/*
Toast 와 동일한 형태의 ConfirmModal
*/
const ConfirmModal = ({ size, title, description, onClose, onConfirm }: ConfirmModalProps) => {
  const el = document.getElementById('modal') as HTMLElement;
  const root = ReactDOM.createRoot(el);

  const handleClose = () => {
    onClose?.();
    root.unmount();
  };

  const handleConfirm = () => {
    onConfirm?.();
    root.unmount();
  };

  const toast = (
    <Modal visible={true} dimmed={true}>
      <div className={cx('layer', size)}>
        {title && <strong className={cx('title')}>{title}</strong>}
        {description && <p className={cx('desc')}>{description}</p>}
        <div className={cx('btnArea')}>
          <a className={cx('btn', 'cancel')} role="button" onClick={handleClose}>
            아니오
          </a>
          <button className={cx('btn', 'confirm')} type="button" onClick={handleConfirm}>
            네
          </button>
        </div>
      </div>
    </Modal>
  );

  root.render(toast);
};

export default ConfirmModal;
